import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { PrivacyMember, PrivacyTeam } from '@shared/dialogs/private-asset-settings-dialog/privacy.model';
import { TeamContactCardService } from '../team-contact-card/team-contact-card.service';
import { Observable } from 'rxjs';
import { rouletter } from '@miq/report-export-view';

const COLORS = [
  '#00b2dd',
  '#ec008c',
  '#a23f97',
  '#f58220',
  '#ffdd00',
  '#69be2b',
  '#004b35',
  '#00a657',
  '#bfd857',
  '#00b5db',
  '#d0021b',
];
const palette = rouletter(COLORS);

@Component({
  selector: 'miq-privacy-team-contact-card',
  templateUrl: './privacy-team-contact-card.component.html',
  styleUrls: ['./privacy-team-contact-card.component.scss'],
  providers: [TeamContactCardService],
  standalone: false,
})
export class PrivacyTeamContactCardComponent implements OnChanges {
  @Input()
  public team: PrivacyTeam;
  @Input()
  public selected: boolean;
  @Input()
  public isOnMIQ: boolean;
  @Input() public selectedContactComponent: boolean;
  @Input() isUserAllowed: boolean;
  @Input() selectedUsersTeams: Array<PrivacyMember | PrivacyTeam> = [];
  @Output()
  public change: EventEmitter<{ checked: boolean; team: PrivacyTeam }> = new EventEmitter();

  public color: string;
  public teamMembers$: Observable<PrivacyMember[]>;

  constructor(private teamContactCardService: TeamContactCardService) {
    this.color = palette.next();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedUsersTeams && changes.selectedUsersTeams.currentValue) {
      const thisCompponentTeam = changes.selectedUsersTeams.currentValue.find(
        item => item.team_id === this.team.team_id
      );
      this.selected = thisCompponentTeam && thisCompponentTeam.selected;
    }
  }

  public getTeamMembers($event): void {
    $event.stopPropagation();
    this.teamMembers$ = this.teamContactCardService.getTeamMembers(this.team.id);
  }

  public onClick(): void {
    if (this.selectedContactComponent) {
      return;
    }
    this.selected = !this.selected;
    this.change.emit({ checked: this.selected, team: this.team });
  }

  removeTeam() {
    this.selected = false;
    this.change.emit({ checked: this.selected, team: this.team });
  }
}
